import { render, staticRenderFns } from "./WorkLoadHistoryRegister.vue?vue&type=template&id=7f6eb611"
import script from "./WorkLoadHistoryRegister.vue?vue&type=script&lang=js"
export * from "./WorkLoadHistoryRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6eb611')) {
      api.createRecord('7f6eb611', component.options)
    } else {
      api.reload('7f6eb611', component.options)
    }
    module.hot.accept("./WorkLoadHistoryRegister.vue?vue&type=template&id=7f6eb611", function () {
      api.rerender('7f6eb611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/control_panel/WorkLoadHistoryRegister.vue"
export default component.exports